import React from "react";
import { keyframes, Box } from "@mui/system";
import { Typography } from "@mui/material";
import * as COLORS from '../../assets/utils/Constants';
import { BRAND_CONFIG } from "../../brand/config";
const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const Loader = () => {
  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        gap: "10px",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          width: 80,
          height: 80,
          borderRadius: "80px 0 0 80px",
          borderLeft: `5px solid ${COLORS.yellowOrange}`,
          animation: `${spin} 1s infinite linear`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            width: 50,
            height: 50,
            borderRadius: "50px 0 0 50px",
            borderLeft: `5px solid ${COLORS.yellowOrange}`,
            animation: `${spin} 3s infinite linear`,
          }}
        />
      </Box>
      <Typography sx={{color:COLORS.yellowOrange, fontSize:"2rem"}}>{BRAND_CONFIG.brand.name}</Typography>
    </Box>
  );
};

export default Loader;
